export const pluginId = 'neo4j-analytics';
